import http from '@/utils/http';


export const subscribeApi = (data) => http.post('/aisale/schedule/', data);


export default {
  subscribeApi
};